import React, { useState } from "react";
import { useStore } from "store";
import axios from "axios";
import strings from "resources/strings";
import { Flex, Typography, Button, Modal, message, theme } from "antd";
const { Text } = Typography;

import "./style.scss";
const styleWrapperClass = "plan";

function ModalSubscriptionResume({ rfc }) {
  const { token: theme_token } = theme.useToken();

  const token = useStore((state) => state.token);
  const setUser = useStore((state) => state.setUser);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isHandlingRequest, setIsHandlingRequest] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsHandlingRequest(false);
    setIsModalOpen(false);
  };

  const handleOk = async () => {
    setIsHandlingRequest(true);

    //Call server
    const res = await postUserRfcResumeSubscription();

    if (res === -1) {
      setIsHandlingRequest(false);
      message.error(strings.alertUnexpectedError);
      return;
    }

    //Update local variables and refresh
    setUser(res);
    message.success(strings.alertSubscriptionResumedSuccess, 10);
  };

  const postUserRfcResumeSubscription = async () => {
    let path = "/user/subscription/abort-cancel";
    let headers = { token: token };
    let payload = {};
    const responseApi = await axios
      .post(path, payload, { headers })
      .catch((error) => {
        return -1;
      });

    const responseCode = responseApi.data.response.code;
    const responseData = responseApi.data.data;

    if (responseCode !== 2000) {
      return -1;
    }

    return responseData;
  };

  return (
    <div className={styleWrapperClass}>
      <Text
        onClick={showModal}
        style={{
          cursor: "pointer",
          textDecoration: "underline",
          color: theme_token.colorPrimary,
        }}
      >
        Reanudar
      </Text>

      <Modal
        title="Reanudar subscripción"
        open={isModalOpen}
        onCancel={handleCancel}
        width={560}
        destroyOnClose={true}
        footer={null}
        maskClosable={!isHandlingRequest}
        closable={!isHandlingRequest}
      >
        <Flex vertical gap={30}>
          <Flex vertical gap={10}>
            <Text style={{ fontSize: "20px", fontWeight: "bold" }}>{rfc}</Text>
            <Text>
              Reanuda tu subscripción antes de que cancele y continúa
              disfrutando los beneficios de tu plan. Tu subscripción se renovará
              en su fecha original, no se hará un cargo en este momento.
            </Text>
          </Flex>
          <Flex justify="flex-end" gap={10}>
            <Button danger disabled={isHandlingRequest} onClick={handleCancel}>
              Cancelar
            </Button>
            <Button
              type="primary"
              loading={isHandlingRequest}
              onClick={handleOk}
            >
              Reanudar
            </Button>
          </Flex>
        </Flex>
      </Modal>
    </div>
  );
}

export default ModalSubscriptionResume;
